export enum FacetCategories {
  MembershipBodies = "Membership Bodies",
  VoiceQuality = "Voice Quality",
  VoiceCharacter = "Voice Character",
  VoiceStyle = "Voice Style",
  FacialHair = "Facial Hair",
  Appearance = "Appearance",
  HairColour = "Hair Colour",
  EyeColour = "Eye Colour",
  HairLength = "Hair Length",
  Nationality = "Nationality",
  BeltNotes = "Belt Notes",
  Disability = "Disability",
  Gender = "Gender",
  HeritageAndEthnicity = "Heritage And Ethnicity",
  EthnicBackground = "Ethnic Background",
  VisasAndWorkingPermits = "Visas & Working Permits",
}
